import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ScienceIcon from '@mui/icons-material/Science';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import GroupsIcon from '@mui/icons-material/Groups';

const ValueDisruption = () => {
  const theme = useTheme();
  const iconProps = { sx: { fontSize: 40, color: theme.palette.primary.main } };

  return (
    <Box>
      <Box marginBottom={2}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          align="center"
          color="primary"
        >
          Por qué Daka debe estar en TNO
        </Typography>
      </Box>
      <Box
        sx={{
          bgcolor: theme.palette.secondary.main,
          color: theme.palette.secondary.contrastText,
          borderRadius: 2,
          py: 4,
          px: 2,
        }}
      >
        <Box marginBottom={4}>
          <Box
            component={Typography}
            fontWeight={700}
            variant="h4"
            gutterBottom
            align="center"
            sx={{ color: theme.palette.primary.main }}
          >
            El valor de la disrupción
          </Box>
          <Typography
            variant="body1"
            align="center"
            sx={{ maxWidth: 800, mx: 'auto', mb: 3, color: theme.palette.primary.main }}
          >
            Para una marca que lidera el retail tecnológico como <strong>Daka</strong>, la presencia en medios
            tradicionales se potencia cuando se <strong>complementa</strong> con una estrategia digital de nueva
            generación. <strong>TNO Network</strong> es la plataforma pionera en Venezuela en formato de Radio
            Visual y ecosistema multiplataforma para conectar, medir y convertir.
          </Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.primary.main}`,
                bgcolor: '#fff',
              }}
            >
              <Box display="flex" justifyContent="center" alignItems="center" marginBottom={1}>
                <ScienceIcon {...iconProps} />
              </Box>
              <Typography variant="h6" gutterBottom fontWeight={700} color="primary">
                Coherencia de innovación
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Los productos de última generación de Daka requieren un entorno que respire tecnología y que
                comunique su promesa: <strong>Sé feliz</strong>. TNO ofrece ese ecosistema.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.primary.main}`,
                bgcolor: '#fff',
              }}
            >
              <Box display="flex" justifyContent="center" alignItems="center" marginBottom={1}>
                <LeaderboardIcon {...iconProps} />
              </Box>
              <Typography variant="h6" gutterBottom fontWeight={700} color="primary">
                Liderazgo tech
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Al ser un medio dirigido por una <strong>Ingeniera de Software (CEO)</strong>, garantizamos una
                infraestructura digital optimizada que permite una integración de marca de vanguardia.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.primary.main}`,
                bgcolor: '#fff',
              }}
            >
              <Box display="flex" justifyContent="center" alignItems="center" marginBottom={1}>
                <GroupsIcon {...iconProps} />
              </Box>
              <Typography variant="h6" gutterBottom fontWeight={700} color="primary">
                UGC y contenido auténtico
              </Typography>
              <Typography variant="body2" color="textSecondary">
                El contenido generado por usuarios o voceros mostrando productos Daka en uso genera <strong>prueba
                social y confianza</strong>: la audiencia ve resultados reales, no solo publicidad. Mayor
                conversión y recordación de marca.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ValueDisruption;
